import { getDocuments } from '../services/documents';

const getPaymentTypes = async (): Promise<any> => {
  const data = await getDocuments('payment/types');
  return data;
};

export { getPaymentTypes };
